import React, { useState } from "react";
import { Tabs, Tab, Box ,Button} from "@mui/material";
import CreateSeriesForm from "../Post Bundles/CreateSeriesForm";
import CreateRequest1 from "../Requests/CreateRequest1";

const CreateSwitcher = ({ loggedIn, userId, handleLogout }) => {
  const [type, setType] = useState("session");
  const [tabIndex, setTabIndex] = useState(0); // Default to the first tab

  const handleTabChange = (event, newValue) => {
    setTabIndex(newValue);
  };

  return (

    <Box sx={{ width: "100%", mt: 2 }}>
      <Box sx={{ display: "flex", justifyContent: "center", gap: 2, mb: 2 }}>
  <Button
    variant={type === "session" ? "contained" : "outlined"}
    onClick={() => setType("session")}
  >
    Session
  </Button>

  <Button
    variant={type === "ai_immersion" ? "contained" : "outlined"}
    onClick={() => setType("ai_immersion")}
  >
    AI Immersion
  </Button>
</Box>
     
      <Tabs value={tabIndex} onChange={handleTabChange} centered>
        <Tab label="Create Series" />
        <Tab label="Create Request" />
      </Tabs>

      {/* Render the selected component below the tabs */}
      <Box sx={{ mt: 3 }}>
        {tabIndex === 0 && (
          <CreateSeriesForm 
  loggedIn={loggedIn} 
  onLogout={handleLogout} 
  
/>
        )}
        {tabIndex === 1 && (
          <CreateRequest1 
  userId={userId} 
  onLogout={handleLogout} 
 
 
/>
        )}
      </Box>
    </Box>
  );
};

export default CreateSwitcher;
